import Vue from 'vue'
import VueRouter from 'vue-router'
import Layout from '@/components/Layout.vue'

// 导入页面组件
import ConstructionGroup from '@/views/BigDataSoftware/ConstructionGroup/index.vue'
import IndicatorClass from '@/views/BigDataSoftware/IndicatorClass/index.vue'
import ProjectClass from '@/views/BigDataSoftware/ProjectClass/index.vue'
import DataAnalysis from '@/views/BigDataSoftware/DataAnalysis/index.vue'
import BillSettings from '@/views/BigDataSoftware/BillSettings/index.vue'
import HistoryData from '@/views/BigDataSoftware/HistoryData/index.vue'
import RegionalQuota from '@/views/BigDataSoftware/RegionalQuota/index.vue'
import EnterpriseQuota from '@/views/BigDataSoftware/EnterpriseQuota/index.vue'

import ProjectSettlementSoftware from '@/views/ProjectSettlementSoftware/index.vue'

import SchemeInvestmentEstimate from '@/views/InvestmentEstimateSoftware/SchemeInvestmentEstimate/index.vue'
import EstimateComparisonAnalysis from '@/views/InvestmentEstimateSoftware/EstimateComparisonAnalysis/index.vue'

import SystemPermissions from '@/views/SystemManagement/SystemPermissions/index.vue'
import ProjectManagementPermissions from '@/views/SystemManagement/ProjectManagementPermissions/index.vue'

import InitialSchemeEstimate from '@/views/DesignBudgetSoftware/InitialSchemeEstimate/index.vue'
import BudgetaryComparisonAnalysis from '@/views/DesignBudgetSoftware/BudgetaryComparisonAnalysis/index.vue'

import TwoEstimateComparisonAnalysis from '@/views/DesignBudgetSoftware/TwoEstimateComparisonAnalysis/index.vue'

import TotalConstructionBudget from '@/views/BillPricingSoftware/TotalConstructionBudget/index.vue'
import ConstructionCostBudget from '@/views/BillPricingSoftware/ConstructionCostBudget/index.vue'
import ThreeEstimateComparisonAnalysis from '@/views/BillPricingSoftware/ThreeEstimateComparisonAnalysis/index.vue'

import wait from '@/views/wait.vue'

Vue.use(VueRouter)

// 可配置的菜单路由配置
export const menuConfig = [
  {
    id: 'project-class',
    name: '工程分类',
    path: '/big-data-software/project-class',
    component: ProjectClass,
    hideSave: true,
    icon: 'el-icon-setting'
  },
  {
    id: 'indicator-class',
    name: '指标分类',
    path: '/big-data-software/indicator-class',
    component: IndicatorClass,
    hideSave: true,
    icon: 'el-icon-setting'
  },
  {
    id: 'construction-group',
    name: '施工班组',
    path: '/big-data-software/construction-group',
    component: ConstructionGroup,
    hideSave: true,
    icon: 'el-icon-setting'
  },
  {
    id: 'bill-settings',
    name: '清单设置',
    path: '/big-data-software/bill-settings',
    component: BillSettings,
    hideSave: true,
    icon: 'el-icon-setting'
  },
  {
    id: 'history-data',
    name: '历史数据',
    path: '/big-data-software/history-data',
    component: HistoryData,
    hideSave: true,
    icon: 'el-icon-time'
  },
  {
    id: 'data-analysis',
    name: '数据分析',
    path: '/big-data-software/data-analysis',
    component: DataAnalysis,
    hideSave: true,
    icon: 'el-icon-setting'
  },
  {
    id: 'total-construction-budget',
    name: '施工总预算',
    path: '/bill-pricing-software/total-construction-budget',
    component: TotalConstructionBudget,
    hideSave: true,
    icon: 'el-icon-edit'
  },
  {
    id: 'regional-quota',
    name: '地区定额',
    path: '/big-data-software/regional-quota',
    component: RegionalQuota,
    hideSave: true,
    icon: 'el-icon-edit'
  },
  {
    id: 'enterprise-quota',
    name: '企业定额',
    path: '/big-data-software/enterprise-quota',
    component: EnterpriseQuota,
    hideSave: true,
    icon: 'el-icon-edit'
  },
  {
    id: 'construction-cost-budget',
    name: '施工成本预算',
    path: '/bill-pricing-software/construction-cost-budget',
    component: ConstructionCostBudget,
    hideSave: true,
    icon: 'el-icon-edit'
  },
  {
    id: 'three-estimate-comparison-analysis',
    name: '三算对比分析',
    path: '/bill-pricing-software/three-estimate-comparison-analysis',
    component: ThreeEstimateComparisonAnalysis,
    hideSave: true,
    icon: 'el-icon-edit'
  },
  {
    id: 'scheme-investment-estimate',
    name: '方案投资估算',
    path: '/investment-estimate-software/scheme-investment-estimate',
    component: SchemeInvestmentEstimate,
    icon: 'el-icon-info',
    hideSave: true
  },
  {
    id: 'estimate-comparison-analysis',
    name: '估算对比分析',
    path: '/investment-estimate-software/estimate-comparison-analysis',
    component: EstimateComparisonAnalysis,
    icon: 'el-icon-info',
    hideSave: true
  },

  {
    id: 'initial-scheme-estimate',
    name: '初步方案概算',
    path: '/design-budget-software/initial-scheme-estimate',
    component: InitialSchemeEstimate,
    icon: 'el-icon-info',
    hideSave: true
  },
  {
    id: 'budgetary-comparison-analysis',
    name: '概算对比分析',
    path: '/design-budget-software/budgetary-comparison-analysis',
    component: BudgetaryComparisonAnalysis,
    icon: 'el-icon-info',
    hideSave: true
  },
  {
    id: 'two-estimate-comparison-analysis',
    name: '两算对比分析',
    path: '/design-budget-software/two-estimate-comparison-analysis',
    component: TwoEstimateComparisonAnalysis,
    icon: 'el-icon-info',
    hideSave: true
  },

  {
    id: 'system-permissions',
    name: '系统功能权限',
    path: '/system-management/system-permissions',
    component: SystemPermissions,
    icon: 'el-icon-info',
    hideSave: true
  },
  {
    id: 'project-management-permissions',
    name: '项目管理权限',
    path: '/system-management/project-management-permissions',
    component: ProjectManagementPermissions,
    icon: 'el-icon-info',
    hideSave: true
  }

  // {
  //   id: 'big-data-software',
  //   name: '大数据软件',
  //   icon: 'el-icon-money',
  //   children: [

  //   ]
  // },
  // {
  //   id: 'bill-pricing-software',
  //   name: '清单计价软件',
  //   icon: 'el-icon-document',
  //   children: [

  //   ]
  // },
  // {
  //   id: 'project-settlement-software',
  //   name: '工程结算软件',
  //   icon: 'el-icon-money',
  //   path: '/project-settlement-software',
  //   component: wait
  // },
  // {
  //   id: 'investment-estimate-software',
  //   name: '投资估算软件',
  //   icon: 'el-icon-coin',
  //   path: '/investment-estimate-software',
  //   children: [
  //     // {
  //     //   id: 'multiple-scheme-design',
  //     //   name: '多种方案设计',
  //     //   path: '/investment-estimate-software/multiple-scheme-design',
  //     //   component: MultipleSchemeDesign,
  //     //   icon: 'el-icon-info',
  //     //   hideSave: true
  //     // },

  //   ]
  // },
  // {
  //   id: 'design-budget-software',
  //   name: '设计概算',
  //   icon: 'el-icon-data-analysis',
  //   children: [
  //     // {
  //     //   id: 'initial-design-scheme',
  //     //   name: '初步设计方案',
  //     //   path: '/design-budget-software/initial-design-scheme',
  //     //   component: InitialDesignScheme,
  //     //   icon: 'el-icon-info',
  //     //   hideSave: true
  //     // },

  //   ]
  // },
  // {
  //   id: 'system-management',
  //   name: '系统管理',
  //   icon: 'el-icon-data-analysis',
  //   children: [

  //   ]
  // }
]

// 生成路由配置
const generateRoutes = menuConfig => {
  const routes = []

  menuConfig.forEach(menu => {
    if (menu.children && menu.children.length > 0) {
      // 处理有子菜单的情况
      menu.children.forEach(child => {
        routes.push({
          path: child.path,
          name: child.id,
          component: child.component,
          meta: {
            title: child.name,
            parentId: menu.id,
            parentName: menu.name,
            icon: child.icon,
            hideSave: child.hideSave
          }
        })
      })
    } else if (menu.path && menu.component) {
      // 处理一级路由的情况
      routes.push({
        path: menu.path,
        name: menu.id,
        component: menu.component,
        meta: {
          title: menu.name,
          icon: menu.icon
        }
      })
    }
  })

  return routes
}

const routes = [
  {
    path: '/',
    component: Layout,
    children: [...generateRoutes(menuConfig)]
  },
  {
    path: '*',
    redirect: '/'
  }
]

const router = new VueRouter({
  mode: 'history',
  base: '/',
  routes
})

export default router
